export const features = ['', 'invoice-management'];
